import { render, staticRenderFns } from "./PRF102M01.vue?vue&type=template&id=04d1222c&"
import script from "./PRF102M01.vue?vue&type=script&lang=js&"
export * from "./PRF102M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports